/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PaginatedResponseWithErrorGeneric } from '../shared/paginated-response-with-error-generic';
import { GetCustomerCompaniesResponseJson } from './get-customer-companies-response-json';
import { GetCustomersResult } from '../results/get-customers-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { CustomerCompanyDto } from '../models/customer-company-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetCustomersResponse extends PaginatedResponseWithErrorGeneric<GetCustomerCompaniesResponseJson, GetCustomersResult> implements IResponseWithErrorGeneric<GetCustomersResult> {
  public customerCompanies: CustomerCompanyDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetCustomersResponse>) {
    super(response, GetCustomersResult.Error);

    if (this.result !== GetCustomersResult.Success) {
      return;
    }

    if (this.body.customerCompanies != null)
      this.customerCompanies = this.body.customerCompanies.map(
        cc => new CustomerCompanyDto(cc)
      );
  }
  //</custom-body>
}
